import React from "react";
import {usePage} from "@inertiajs/react";
import {useEnhancedTranslation} from "laravel-inertia-backend";
import InertiaTable from "laravel-inertia-react-table"

export default function Tasks(props) {
    const { t,getLocales } = useEnhancedTranslation();
    const {tasks} = usePage().props;

    return (<InertiaTable data={tasks}/>);
}
